module.exports = __webpack_public_path__ + "static/img/celoscope-16.cc5e2a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-16.jpg
// module id = ygIe
// module chunks = 51